<template>
  <div id="app">
    <router-view />
    <Loading v-if='LOADING'/>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Loading from './components/Loading'

export default {
  components: {
    Loading
  },
  computed:{
    ...mapState([
      'LOADING'
    ])
  },
  name: 'App'
}
</script>

<style lang="less">
@import "./style/normalize.css";
html,body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, /* structural elements 结构元素 */
dl, dt, dd, ul, ol, li, /* list elements 列表元素 */
pre, /* text formatting elements 文本格式元素 */
fieldset, lengend, button, input, textarea, /* form elements 表单元素 */
th, td {
  /* table elements 表格元素 */
  margin: 0;
  padding: 0;
  height: 100%;
}
#app {
  max-width: 540px;
  margin: 0 auto;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
</style>
